import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Field } from 'redux-form'

import { renderAutocomplete } from '../../fieldRenderers'
import { required, validLocalidad } from '../../fieldValidators'
import { parseLocalidadName, parseLocalidadCodigo }
  from '../../../../models/entity'
import * as actions from '../../../Autocomplete/actions'

class LocalidadAutocomplete extends Component {
  constructor (props) {
    super(props)
    this.handleChange = this.handleChange.bind(this)
    this.handleOnBlur = this.handleOnBlur.bind(this)
    this.handleSelect = this.handleSelect.bind(this)
  }

  handleChange ({ value, reason }) {
    if (reason === 'input-changed') { this.props.requestLocalidad(value) }
  }

  handleOnBlur (e, { highlightedSuggestion }, input) {
    if (
      !parseLocalidadName(e.target.value) ||
      !parseLocalidadCodigo(e.target.value)) {
      e.target.value =
        highlightedSuggestion && highlightedSuggestion['localidad']
      input.onChange(e)
    }
  }

  handleSelect (e, { suggestion, suggestionValue }, input) {
    e.target.value = suggestionValue
    input.onChange(e)
  }

  render () {
    const {
      values = []
    } = this.props

    return (
      <Field
        name='localidad'
        label='Localidad *'
        component={renderAutocomplete}
        validate={[required, validLocalidad]}
        entity='localidad'
        placeholder='Localidad - (12345)'
        values={values}
        type='text'
        onChangeInput={this.handleChange}
        onBlurInput={this.handleOnBlur}
        onSuggestionSelected={this.handleSelect}
      />
    )
  }
};

const mapStateToProps = (state) => ({
  values: state.autocomplete.localidadValues
})

const withRedux = connect(mapStateToProps, actions)

export default withRedux(LocalidadAutocomplete)
